<template>
    <AppLayout title="Grafico SLA">
        <Breadcrumb route="sla_envios_consulta" page="Grafico SLA" />
        <div>
            <div class="sla bg-white">
                <Chart :dias_e="dias_e" :dias_r="dias_r" :proveedor="proveedor" :cordon_o="cordon_o" :cordon_porciento="cordon_porciento"></Chart>
            </div>
        </div>
    </AppLayout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout";
import { defineComponent } from 'vue';
import { Head, Link } from '@inertiajs/inertia-vue3';
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Chart from './Components/Chart.vue';
export default defineComponent ({
  props:{
    dias_e: Array,
    dias_r: Array,
    proveedor: Array,
    cordon_o: Array,
    cordon_porciento: Array
  },
  components: { 
    AppLayout,
    Head,
    Link,
    highcharts:Chart,
    Chart,
    Breadcrumb,
  },
});
</script>

<style>
.v-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.v-danger-icon {
    color: #e30032;
}

.sla .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sla .p-datatable-header {
    background: white;
    border-top: none;
}
.sla .p-inputtext-sm {
    border-radius: 0.5rem;
}

.sla .p-datatable-header {
    background: white;
    border-top: none;
}
.sla .p-inputtext-sm {
    border-radius: 0.5rem;
}
.sla .p-inputtext-sm:hover {
    border-color: #2e5f98;
}
.sla .p-inputtext-sm:enabled:focus {
    border-color: #2e5f98;
    box-shadow: 0 0 0 1px #2e5f98;
}
.sla .p-paginator .p-paginator-pages .p-paginator-page.p-highlight:focus {
    border-color: #2e5f98;
}
.sla .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    border-color: #2e5f98;
}

.sla .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    color: #2e5f98;
}
.sla .p-link:focus {
    box-shadow: 0 0 0 1px #2e5f98;
}

.sla .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}

.sla .p-dropdown:not(.p-disabled).p-focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}

.sla li.p-dropdown-item.p-highlight,
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}
</style>
